'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
// import { CheckIcon } from '@radix-ui/react-icons'

import { cn } from '../helpers/index.js'
import { cva, type VariantProps } from 'class-variance-authority'

const CheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.5 15.8333L1.66667 10L3.75 7.91667L7.5 11.6667L16.25 3L18.3333 5.08333L7.5 15.8333Z"
        fill="currentColor"
      />
    </svg>
  )
}

const checkboxVariants = cva(
  'border-primary ring-offset-background focus-visible:ring-ring data-[state=checked]:bg-brand-0 disabled:bg-btn-primary-disabled peer shrink-0 rounded-sm border focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:text-white',
  {
    variants: {
      size: {
        sm: 'size-[14px]',
        base: 'size-4',
        lg: 'size-5',
      },
    },
    defaultVariants: {
      size: 'base',
    },
  }
)

interface CheckboxProps
  extends React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>, VariantProps<typeof checkboxVariants> {
  iconClassName?: string
}

/**
 * Checkbox - 复选框
 *
 * @description 允许用户进行多选操作的复选框组件，支持不同尺寸和自定义图标
 */
const Checkbox = React.forwardRef<React.ElementRef<typeof CheckboxPrimitive.Root>, CheckboxProps>(
  ({ className, size, iconClassName, ...props }, ref) => (
    <CheckboxPrimitive.Root ref={ref} className={cn(checkboxVariants({ size }), className)} {...props}>
      <CheckboxPrimitive.Indicator className={cn('flex size-full items-center justify-center text-current')}>
        <CheckIcon width={16} height={12} className={iconClassName} />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
)
Checkbox.displayName = 'Checkbox'

export default Checkbox
export type { CheckboxProps }
